<template>
  <div class="Lucy">
    <ol>
      <li>제한시간 동안 나무를 가장 많이 구해 온 사람이 승리합니다</li>
      <li>제한 시간 내에 도착해야 하며, 도착하지 못하면 탈락합니다</li>
      <li>
        <div>주먹으로 pvp가 가능합니다</div>
        <div>단, 방해만 가능할 뿐 죽여서는 안됩니다</div>
      </li>
      <li>트리가드가 나올 경우, 솔방울을 바닥에 심으면 트리가드를 잠재울 수 있습니다</li>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'Lucy'
}
</script>


// WEBPACK FOOTER //
// src/components/Mission/Lucy.vue